import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSelectionList } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for updating a Selection List.
 */
export const useUpdateSelectionList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutationFn - Function to call updateSelectionList.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.SelectionList['id']} params.id - The ID of the Selection List to update.
     * @param {Pella.ProductionRequestAPI.UpdateSelectionListInput} params.input - The inputs for updating the Selection List.
     */
    mutationFn: ({ id, input }) => updateSelectionList(id, input),
    onSuccess: () => {
      toast.dismiss();
      toast.success('Selection List updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
